import { CustomizedStatusSelectWrapper } from 'components/common/CustomizedStatusSelect/CustomizedStatusSelectWrapper/CustomizedStatusSelectWrapper';
import classes from 'components/common/Tables/Cells/StatusCell/StatusCell.module.scss';

import { IStatus } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { CardType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';

interface Props {
    status: IStatus;
    originalStatus: IStatus | null;
    isVirtual: boolean;
    taskId: string | number;
    invalidateQueriesKey: string[];
    cardType: CardType;
    category: any;
    isStatusDisabled?: boolean;
    isInterimChanged?: boolean;
}
export const StatusCell = ({
    status,
    isVirtual,
    taskId,
    originalStatus,
    invalidateQueriesKey,
    cardType,
    category,
    isStatusDisabled = false,
    isInterimChanged,
}: Props) => {
    const isProgramActivity = cardType === 'PROGRAMME_ACTIVITY';

    return (
        <div className={classes.statusCell}>
            <div className={classes.contentWrapper}>
                <CustomizedStatusSelectWrapper
                    category={category}
                    disabled={isStatusDisabled}
                    isProgramActivity={isProgramActivity}
                    status={status}
                    taskId={taskId}
                    isVirtual={isVirtual}
                    invalidateQueriesKey={invalidateQueriesKey}
                    originalStatus={originalStatus}
                    isInterimChanged={isInterimChanged}
                />
            </div>
        </div>
    );
};
